import React from 'react';
import { View } from 'react-native';

import Text from '../../components/text/Text';
import { MachineChip } from '../../design/components';
import { useThemedStyles } from '../../hooks/useThemedStyles';

/** The stops covered by one shared key, pass or piece of equipment. */
const AccessItemStops = ({ stops }) => {
	const styles = useThemedStyles(createStyles);
	const sites = new Map();
	stops.forEach((stop) => {
		const location = stop.docket.machine?.location;
		const key = location?.id || stop.docket.id;
		if (!sites.has(key)) {
			sites.set(key, { name: location?.name || 'Unnamed stop', stops: [] });
		}
		sites.get(key).stops.push(stop);
	});

	return Array.from(sites, ([key, site]) => (
		<View key={key} style={styles.site}>
			<Text style={styles.name}>{site.name}{site.stops.length > 3 ? ` · ${site.stops.length} stops` : ''}</Text>
			{site.stops.length > 3 ? (
				<View style={styles.position}>
					{site.stops.map(({ docket }) => <MachineChip key={docket.id} number={docket.machine?.assetId} />)}
				</View>
			) : site.stops.map(({ docket }) => (
				<View key={docket.id} style={styles.position}>
					{Boolean(docket.machine?.place?.name) && <Text style={styles.place}>{docket.machine.place.name}</Text>}
					<MachineChip number={docket.machine?.assetId} />
				</View>
			))}
		</View>
	));
};

const createStyles = ({ ui: { colors, space, type } }) => ({
	site: {
		gap: space.xs,
	},
	name: {
		...type.bodySmallSemibold,
		color: colors.text,
	},
	position: {
		flexDirection: 'row',
		flexWrap: 'wrap',
		alignItems: 'center',
		gap: space.sm,
	},
	place: {
		...type.caption,
		color: colors.textSecondary,
		flexShrink: 1,
	},
});

export default AccessItemStops;
